import { HttpResponseError } from '@app/src/utils/validations';
import { hydrateUser } from './hydrators';
import { HttpStatus } from '@app/src/utils/validations/constants';
import axios from 'axios';

export const serviceUser = {
  async login(values, url) {
    try {
      const data = await axios.post(url, {
        username: values.username,
        password: values.password
      });
      const refreshtoken = data.headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if (data.data.code === HttpStatus.LOGIN_ERROR) {
        return data.data;
      }
      return hydrateUser(data.data);
    } catch (error) {
      throw new HttpResponseError(error);
    }
  }
}
